import PropTypes from 'prop-types';
import qs from 'qs';
import React from 'react';
import { withRouter } from 'react-router';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import styled from 'styled-components';

const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 15px;
  box-sizing: border-box;

  @media (min-width: 700px) {
    justify-content: flex-end;
  }
`;

const PaginationRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const ButtonWrapper = styled.button`
  ${
    '' /* display: flex;
  justify-content: center;
  align-items: center; */
  }
  width: 40px;
  height: 40px;
  background: #fa4616;
  border: 1px solid #cccccc;
  color: #fff;
  border-radius: 3px;
  margin: 0 5px;
  padding: 0px;
  font-size: 35px;
  font-family: 'Barlow Condensed';
  line-height: 32px;

  &:disabled {
    opacity: 0.45;
  }
`;

const PaginationText = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  margin: 0 5px;
  ${(props) => (props.color ? `color: ${props.color}` : '')};
`;

const Button = ({ children, ...props }) => {
  return <ButtonWrapper {...props}>{children}</ButtonWrapper>;
};

const Pagination = ({ count, perPage = 15, currentPage, color, ...props }) => {
  const pages = Math.ceil(count / perPage);

  const { pathname, search: rawSearch } = useLocation();
  const search = qs.parse(rawSearch, { ignoreQueryPrefix: true });

  const firstPage = () => {
    const value = 1;

    props.history.replace(
      `${pathname}?${qs.stringify({
        ...search,
        page: value,
      })}`
    );
  };

  const nextPage = () => {
    const value = currentPage + 1;

    props.history.push(
      `${pathname}?${qs.stringify({
        ...search,
        page: value,
      })}`
    );
  };

  const prevPage = () => {
    const value = currentPage - 1;

    props.history.replace(
      `${pathname}?${qs.stringify({
        ...search,
        page: value,
      })}`
    );
  };

  const lastPage = () => {
    const value = pages;

    props.history.push(
      `${pathname}?${qs.stringify({
        ...search,
        page: value,
      })}`
    );
  };

  return (
    <PaginationWrapper>
      <PaginationRow>
        <PaginationText color={color}>{count} items</PaginationText>

        <Button onClick={firstPage} disabled={currentPage < 2}>
          <div style={{ marginBottom: 10 }}>&laquo;</div>
        </Button>
        <Button onClick={prevPage} disabled={currentPage < 2}>
          <div style={{ marginBottom: 10 }}>&lsaquo;</div>
        </Button>

        <PaginationText color={color}>
          {currentPage} of {pages}
        </PaginationText>

        <Button onClick={nextPage} disabled={currentPage === pages}>
          <div style={{ marginBottom: 10 }}>&rsaquo;</div>
        </Button>
        <Button onClick={lastPage} disabled={currentPage === pages}>
          <div style={{ marginBottom: 10 }}>&raquo;</div>
        </Button>
      </PaginationRow>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
};

Pagination.defaultProps = {
  currentPage: 1,
};

export default withRouter(Pagination);
